<!-- Asset Recipients -->
@if (!!assetRecipientCountsByLayer?.length) {
  <div
    class="assets"
    >
    <div
      class="asset-recipients"
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        <topo-checkbox
          [checked]="includeAssetsRecipients"
          [indeterminate]="assetsInIndeterminateState()"
        (checkChanged)="onIncludeAssetsRecipientsChanged(true)"></topo-checkbox>
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          @if (_closestAssetRequest?.withinMeters > 0) {
            {{ 'COMMUNICATIONS.ASSET-RECIPIENTS-WITHIN-RADIUS' | translate }}
          } @else {
            {{ 'COMMUNICATIONS.ASSET-RECIPIENTS-WITHIN-SELECTION' | translate }}
          }
          <div class="total-counter">
            {{ totalAssetRecipients }}
          </div>
        </div>
      </div>
      @if (includeAssetsRecipients && totalAssetRecipients > 0) {
        <div
          class="asset-actions"
          fxLayout="row"
          fxLayoutAlign="center center">
          <i
            title="{{ 'COMMUNICATIONS.BUTTONS.SHOW-DETAILS' | translate }}"
            class="icon icon-table_2 select-all-button"
          (click)="onSelectAllAssets()"></i>
        </div>
      }
    </div>
    @for (lay of assetRecipientCountsByLayer; track lay.layer.uId; let last = $last) {
      <div>
        <div
          class="layer-group"
          [ngClass]="{ 'last-in-child': last }">
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center">
            <div
              fxLayout="row"
              fxLayoutAlign="start center">
              <topo-checkbox
                [checked]="lay.include"
                [indeterminate]="assetInIndeterminateState(lay)"
              (checkChanged)="onIncludeAssetRecipientChanged(lay, $event)"></topo-checkbox>
              <div
                fxLayout="row"
                fxLayoutAlign="start center">
                @if (!lay?.layer?.isCustomIcon) {
                  <div
                    class="asset-icon"
                    [style]="'background-color:' + (lay.layer?.color || '#FFFFFF') + ';color: #FFFFFF'"
                    fxLayout="row"
                    fxLayoutAlign="space-around center">
                    <div
                      class="material-icons"
                      style="font-size: 16px">
                      {{ lay.layer?.iconPath }}
                    </div>
                  </div>
                }
                @if (!!lay?.layer?.isCustomIcon) {
                  <div
                    class="asset-icon"
                    [style]="'background-color:' + (!lay ? '#FFFFFF' : lay.layer?.color) + ';color: #FFFFFF'">
                    <img
                      [src]="lay.layer?.iconPath | safeUrl"
                      style="width: 16px; height: 16px; margin: 4px 0px 0px 4px" />
                  </div>
                }
                <div
                  style="font-weight: 600"
                  class="asset-name ml-2">
                  {{ lay?.layer?.name }}
                </div>
                <div class="asset-count ml-1">
                  ({{ getSelectedCount(lay) }}/{{ lay?.count }})
                  @if (!!!lay?.contactCount && lay.include === true) {
                    <span
                      class="no-count-warning-text">
                      <i class="icon icon-small_solid_warning no-count-warning"></i>
                      {{ 'COMMUNICATIONS.NO-TOTAL-CONTACTS' | translate }}
                    </span>
                  }
                  @if (!!lay?.contactCount && lay.include === true) {
                    <span
                      class="contact-count">
                      &nbsp; {{ 'COMMUNICATIONS.TOTAL-CONTACTS' | translate : { number: lay?.contactCountDisplay } }}
                    </span>
                  }
                </div>
              </div>
            </div>
            <div
              class="asset-actions"
              fxLayout="row"
              fxLayoutAlign="center center">
              <i
                title="{{ 'COMMUNICATIONS.BUTTONS.SHOW-DETAILS' | translate }}"
                class="icon icon-small_table_2"
              (click)="onSelectAsset(lay)"></i>
            </div>
          </div>
          <!-- Related Section -->
          @for (rel of lay.relatedInfoItems; track rel.datasetUId) {
            <div>
              <div
                fxLayout="row"
                fxLayoutAlign="space-between center"
                class="mt-2">
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center">
                  <div class="include-related">
                    <topo-checkbox
                      [disabled]="!lay.include"
                      [checked]="lay.include && rel.include"
                    (checkChanged)="onSendToRelatedAssetsChanged(lay, rel)"></topo-checkbox>
                  </div>
                  <div
                    fxLayout="row"
                    fxLayoutAlign="start center">
                    @if (!rel.isCustomIcon) {
                      <div
                        class="asset-icon"
                        [style]="'background-color:' + (rel.color || '#FFFFFF') + ';color: #FFFFFF'"
                        fxLayout="row"
                        fxLayoutAlign="space-around center">
                        <div
                          class="material-icons"
                          style="font-size: 16px">
                          {{ rel.iconPath }}
                        </div>
                      </div>
                    }
                    @if (!!rel.isCustomIcon) {
                      <div
                        class="asset-icon"
                        [style]="'background-color:' + (!rel ? '#FFFFFF' : rel?.color) + ';color: #FFFFFF'">
                        <img
                          [src]="rel?.iconPath | safeUrl"
                          style="width: 16px; height: 16px; margin: 4px 0px 0px 4px" />
                      </div>
                    }
                    <div class="asset-name ml-2">
                      {{ rel.datasetName }}
                    </div>
                    <div class="asset-count ml-1">
                      @if (rel.hasDocumentFilter == true) {
                        <span>({{ rel.count }})</span>
                      }
                      @if (rel.hasDocumentFilter != true) {
                        <span>({{ getRelatedSelectedCount(rel) }}/{{ rel.count }})</span>
                      }
                      @if (!!!rel.contactCount && rel.include === true) {
                        <span
                          class="no-count-warning-text">
                          <i class="icon icon-small_solid_warning no-count-warning"></i>
                          {{ 'COMMUNICATIONS.NO-TOTAL-CONTACTS' | translate }}
                        </span>
                      }
                      @if (!!rel.contactCount && rel.include === true) {
                        <span
                          class="contact-count">
                          &nbsp; {{ 'COMMUNICATIONS.TOTAL-CONTACTS' | translate : { number: rel.contactCount } }}
                        </span>
                      }
                    </div>
                  </div>
                </div>
                @if (rel.hasDocumentFilter !== true && includeAssetsRecipients === true && lay.include == true && rel.include === true) {
                  <div
                    class="asset-actions"
                    fxLayout="row"
                    fxLayoutAlign="center center">
                    <i
                      title="{{ 'COMMUNICATIONS.BUTTONS.SHOW-DETAILS' | translate }}"
                      class="icon icon-small_table_2"
                    (click)="onSelectAssetRelated(lay, rel)"></i>
                  </div>
                }
              </div>
            </div>
          }
          <!-- -->
        </div>
      </div>
    }
  </div>
}

<topo-comms-recipient-assets-selection-list
  [activeContext]="assetsSelectionContext"
  [getSelectedUIds]="getAssetSelectedUIds"
  (recipientsSelected)="assetRecipientsSelected($event)"
(recipientsSelectionClosed)="onCloseRecipientSelection()"></topo-comms-recipient-assets-selection-list>
